const footer = [
  {
    text: "Contact Us",
    subList: [
      { text: "polyticks.app@gmail.com", href: "mailto:polyticks.app@gmail.com"},
      { text: "+233 (0)20 366 9141", href: "tel:+233203669141"},
      { text: "+233 (0)55 771 1911", href: "tel:+233557711911"},
    ],
  },
 
  {
    text: "Our Customers",
    subList: [
      { text: "Pentagon Hostel" },
      { text: "Evandy Hostel" },
      { text: "ESUG" },
      { text: "ATU" },
      { text: "IAESTE, UG" },
    ],
  },
 
];

export default footer;
